import { jsxs as h, jsx as l } from "react/jsx-runtime";
import { forwardRef as B } from "react";
import { B as _ } from "./Banner-BBfZio8n.js";
import { B as C } from "./Button-icgr8OM9.js";
function O(t) {
  return t < 0 ? "expired" : t === 0 ? "endingToday" : t <= 2 ? "urgent" : "normal";
}
const w = {
  normal: "accent",
  urgent: "orange",
  endingToday: "warning",
  expired: "error"
};
function E(t, {
  label: r,
  labelUrgent: i,
  labelEndingToday: a,
  labelExpired: s
}) {
  switch (t) {
    case "urgent":
      return i ?? r;
    case "endingToday":
      return a ?? r;
    case "expired":
      return s ?? r;
    case "normal":
    default:
      return r;
  }
}
const L = B(
  function(r, i) {
    const {
      daysLeft: a,
      state: s,
      title: u,
      label: m,
      labelUrgent: v,
      labelEndingToday: f,
      labelExpired: g,
      cancelLabel: o,
      upgradeLabel: d,
      onCancel: p,
      onUpgrade: c,
      compact: T = !1,
      ...e
    } = r, n = s ?? O(a), y = w[n], b = E(n, { label: m, labelUrgent: v, labelEndingToday: f, labelExpired: g });
    return T ? /* @__PURE__ */ l(
      x,
      {
        ref: i,
        daysLeft: a,
        state: n,
        label: b,
        upgradeLabel: d,
        cancelLabel: o,
        onUpgrade: c,
        onCancel: p,
        ...e
      }
    ) : /* @__PURE__ */ l(
      _,
      {
        ref: i,
        tone: y,
        variant: "soft",
        title: u,
        action: o || d ? /* @__PURE__ */ h("span", { style: { display: "inline-flex", gap: "var(--space-2)" }, children: [
          o && p ? /* @__PURE__ */ l(C, { variant: "ghost", size: "sm", onClick: p, children: o }) : null,
          d && c ? /* @__PURE__ */ l(C, { variant: "primary", size: "sm", onClick: c, children: d }) : null
        ] }) : null,
        "data-ls-component": "trial-banner",
        "data-state": n,
        "data-days-left": a,
        ...e,
        children: b
      }
    );
  }
);
L.displayName = "TrialBanner";
const S = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
  padding: "var(--space-2) var(--space-3)",
  borderRadius: "var(--radius-lg)",
  borderStyle: "solid",
  borderWidth: "1px",
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-2xs)",
  lineHeight: "var(--line-sm)",
  width: "100%"
}, A = {
  normal: {
    bg: "var(--accent-dim)",
    border: "var(--accent-border)",
    fg: "var(--accent-default)"
  },
  urgent: {
    bg: "var(--orange-bg)",
    border: "var(--orange-border)",
    fg: "var(--orange)"
  },
  endingToday: {
    bg: "var(--warning-bg)",
    border: "var(--warning-border)",
    fg: "var(--warning)"
  },
  expired: {
    bg: "var(--error-bg)",
    border: "var(--error-border)",
    fg: "var(--error)"
  }
}, k = {
  normal: "status",
  urgent: "status",
  endingToday: "alert",
  expired: "alert"
}, R = {
  normal: "polite",
  urgent: "polite",
  endingToday: "assertive",
  expired: "assertive"
}, x = B(
  function(r, i) {
    const {
      daysLeft: a,
      state: s,
      label: u,
      labelUrgent: m,
      labelEndingToday: v,
      labelExpired: f,
      upgradeLabel: g,
      onUpgrade: o,
      // cancelLabel + onCancel intentionally accepted but ignored in compact
      // — keeps the prop surface aligned for callers that pass both.
      cancelLabel: d,
      onCancel: p,
      style: c,
      ...T
    } = r, e = s ?? O(a), n = A[e], y = E(e, { label: u, labelUrgent: m, labelEndingToday: v, labelExpired: f }), b = {
      ...S,
      background: n.bg,
      borderColor: n.border,
      color: "var(--text-primary)",
      ...c
    };
    return /* @__PURE__ */ h(
      "div",
      {
        ref: i,
        role: k[e],
        "aria-live": R[e],
        "data-ls-component": "trial-banner",
        "data-variant": "compact",
        "data-state": e,
        "data-days-left": a,
        style: b,
        ...T,
        children: [
          /* @__PURE__ */ l("span", { style: { flex: "1 1 auto", minWidth: 0, color: n.fg }, children: y }),
          g && o ? /* @__PURE__ */ l(C, { variant: "primary", size: "sm", onClick: o, children: g }) : null
        ]
      }
    );
  }
);
x.displayName = "TrialBanner.Compact";
const j = Object.assign(L, {
  Compact: x
});
export {
  j as T,
  x as a,
  O as d
};
//# sourceMappingURL=TrialBanner-aEyvjLPc.js.map
